(function () {
  function getTrack(root) {
    return root.querySelector('[data-heathen-archive-track]');
  }

  function getStep(track) {
    var first = track.querySelector('a');
    if (!first) return 360;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.gap || style.columnGap || '8') || 8;
    return Math.round(first.getBoundingClientRect().width + gap);
  }

  function updateArrows(root, track) {
    var prev = root.querySelector('[data-heathen-archive-prev]');
    var next = root.querySelector('[data-heathen-archive-next]');
    if (!prev || !next || !track) return;

    var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft >= max;

    prev.classList.toggle('slick-disabled', atStart);
    next.classList.toggle('slick-disabled', atEnd);
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function bindRoot(root) {
    if (!root || root.dataset.heathenArchiveBound === '1') return;
    var track = getTrack(root);
    if (!track) return;

    root.dataset.heathenArchiveBound = '1';
    var prev = root.querySelector('[data-heathen-archive-prev]');
    var next = root.querySelector('[data-heathen-archive-next]');

    if (prev) {
      prev.addEventListener('click', function () {
        if (prev.classList.contains('slick-disabled')) return;
        track.scrollBy({ left: -getStep(track), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (next.classList.contains('slick-disabled')) return;
        track.scrollBy({ left: getStep(track), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      updateArrows(root, track);
    });

    window.addEventListener('resize', function () {
      updateArrows(root, track);
    });

    updateArrows(root, track);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-heathen-archive-products]').forEach(bindRoot);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-heathen-archive-products]').forEach(bindRoot);
  });
})();
